// Replacing Unibabel package
function binaryStringToBuffer(binstr) {
	let buffer;

	if ('undefined' !== typeof Uint8Array) {
		buffer = new Uint8Array(binstr.length);
	} else {
		buffer = [];
	}

	Array.prototype.forEach.call(binstr, function (ch, i) {
		buffer[i] = ch.charCodeAt(0);
	});

	return buffer;
}

function base64ToBuffer(base64) {
	const buf = Buffer.from(base64, 'base64');
	return buf;
}

//=============================================================================
//
// Delegates to functions above to carry out base 64 deccoding of a base64 object
// Returns a string containing the decoded result.
//
//=============================================================================
class Base64Decoder {

    //=============================================================================
    // Returns a string containing the decoded result,
    // or nothing if input is not a string.
    //=============================================================================
	static decodeToString( base64Str ) {
		if ( typeof base64Str === 'string' ) {
			const buffer = base64ToBuffer(base64Str);
			return binaryStringToBuffer(buffer);
		}
		return undefined;
	}

    //=============================================================================
    // Returns a UTF-8 array containing the decoded result,
    // (returns nothing if input is not a string.
    //=============================================================================
    static decodeToArray( base64Str ) {
        if ( typeof base64Str === 'string' ) {
            return base64ToBuffer(base64Str);
        }
        return undefined;
    }
}

export default Base64Decoder;
